import { createStore } from "vuex";
import { auth } from "./auth.module";
import { count } from "./count.module";

const store = createStore({
  modules: {
    auth,
    count,
  },
});

export default store;